import { SupportedLocale } from 'shared/legacy/contexts/LocalizationContext/types';

/**
 * @returns 'MON, 09 FEB' or 'MON, 09 FEB 10:00'
 */
export const formatDate = (
  dateString: string | Date,
  locale: SupportedLocale,
  includeHour?: boolean,
  hideLastComma = false,
) => {
  const formattedLocale = locale === 'en-US' ? 'en-UK' : locale;

  try {
    const date = new Date(dateString);
    const formattedDate = new Intl.DateTimeFormat(formattedLocale, {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      hour: includeHour ? '2-digit' : undefined,
      minute: includeHour ? '2-digit' : undefined,
      hour12: includeHour ? false : undefined,
    })
      .format(date)
      .toUpperCase();

    if (hideLastComma) return formattedDate.replace(/,([^,]*)$/, '$1');
    return formattedDate;
  } catch {
    return 'Invalid Date';
  }
};

/**
 * @returns 'MONDAY, 9 FEBRUARY, 2026' or 'MONDAY, 9 FEBRUARY, 2026 AT 10:00'
 */
export const formatFullDate = (
  dateString: string | Date,
  locale: SupportedLocale,
  includeHour?: boolean,
  uppercase = true,
) => {
  const formattedLocale = locale === 'en-US' ? 'en-UK' : locale;

  try {
    const date = new Date(dateString);
    const formatted = new Intl.DateTimeFormat(formattedLocale, {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: includeHour ? '2-digit' : undefined,
      minute: includeHour ? '2-digit' : undefined,
      hour12: includeHour ? false : undefined,
    }).format(date);

    return uppercase ? formatted.toUpperCase() : formatted;
  } catch {
    return 'Invalid Date';
  }
};

/**
 * @returns '2/13/26' or '2/13/26, 10:00 AM'
 */
export const formatShortDate = (dateString: string | Date, locale: SupportedLocale, includeHour?: boolean) => {
  const formattedLocale = locale === 'en-US' ? 'en-UK' : locale;

  try {
    const date = new Date(dateString);

    return new Intl.DateTimeFormat(formattedLocale, {
      dateStyle: 'short',
      timeStyle: includeHour ? 'short' : undefined,
    }).format(date);
  } catch {
    return 'Invalid Date';
  }
};
